import { useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_FAVICON = '/favicon.png';

const useDynamicFavicon = (empresaCodigo) => {
  useEffect(() => {
    const link = document.getElementById('dynamic-favicon') || document.querySelector("link[rel='icon']");
    if (link) {
      link.href = empresaCodigo
        ? `${API_URL}/api/empresas/${empresaCodigo}/logo`
        : DEFAULT_FAVICON;
    }
  }, [empresaCodigo]);
};

export default useDynamicFavicon;
